function BrowserPushManager(){
    var instancevars = {
        localStorageKey: 'browser-permission-modal-shown',
        localStorageKeyForAvoidCheck: 'skip-bp-check',
        isUserSeller: function(){
            // not necessary at this point because script is only included if user is seller
            return true;
        },
        isFirstSession: function() {
            return Bark.get_cookie('seller_first_session') == 1;
        },
        pushModalShown: function(){
            return localStorage.getItem(this.localStorageKey);
        },
        shouldAvoidCheck: function(){
            return false
                || localStorage.getItem(this.localStorageKeyForAvoidCheck)
                || this.pushModalShown();
        },
        setShouldAvoidCheck: function(bool){
            try {
                localStorage.setItem(this.localStorageKeyForAvoidCheck, bool);
            } catch (ignore) {}
        },
        setPushModalShown: function(bool){
            localStorage.setItem(this.localStorageKey, bool);
        },
        browserPushAvailableAsync: function(callback){
            if(typeof(callback) !== 'function'){
                throw new Error("You must provide a callback function");
            }
            OneSignal.push(function () {
                if(OneSignal.isPushNotificationsSupported()){
                    return OneSignal.push(["getNotificationPermission", function(p) {
                        if (p === 'denied') {
                            callback(false);
                        } else {
                            callback(true);
                        }
                    }]);
                }
                else{
                    callback(false);
                }
            });
        },
        checkPushEnabledAsync: function(callback){
            OneSignal.push(function(){
                OneSignal.isPushNotificationsEnabled(function(isEnabled){
                    // isEnabled is a boolean value already so we can just be wrapping it.
                    callback(isEnabled);
                });
            });
        },
        /*
        This function will return true if the user has any push notifications enabled
         */
        checkUserHasPushNotificationSettingsEnabledAsync: function(callback){
            Bark.api(
                'seller/notifications/webpush',
                {},
                function(data){
                    try{
                        if(data.status){
                            callback(data.data.enabled);
                        }
                        else{
                            callback(false);
                        }
                    }
                    catch(error){
                        callback(false);
                    }
                },
                function(error){
                    callback(false);
                },
                'GET',
                Bark.apiVersionHeader('v2')
            );
        },
        checkPermissionAndShowModal: function(){
            var t = this;
            // first check if its even necessary to do any of this
            if(!t.shouldAvoidCheck() && t.isUserSeller() && !t.isFirstSession()){
                // check browser is worth investigating, ie push supported and not denied
                t.browserPushAvailableAsync(function(available){
                    if(available){
                        // check with oneSignal if push is already enabled
                        t.checkPushEnabledAsync(function(enabled){
                            // if push is avail but not enabled, we act
                            if(!enabled){
                                t.checkUserHasPushNotificationSettingsEnabledAsync(function(hasPushSettings){
                                    // if the user has any push notification settinsg enabled, we want to ask for permission
                                    if(hasPushSettings){
                                        t.createPermissionModal(true);
                                    }
                                });
                            } else{
                                t.setShouldAvoidCheck(true);
                            }
                        });
                    } else {
                        t.setShouldAvoidCheck(true);
                    }
                });
            }
        },
        createPermissionModal: function(show){
            if (typeof show === 'undefined') {
                show = false;
            }
            if(show && $('.modal.show').length > 0){
                return;
            }
            var t = this;
            var template = $('#hb-browser-push-template').text();
            var modalContent = $('#hb-browser-push-permission-modal').text();
            var modal_render = Handlebars.compile(template);

            $('#browser-push-modal-container').html(
                modal_render({
                    modal_id: 'browser-push-seek-push-permission',
                    title: "",
                    content: modalContent,
                    action_buttons:[],
                    class: 'modal-xs'
                })
            );

            $('#browser-push-permission-modal-allow').on('click', t.permissionModalSubmitHandler);
            if(show){
                $('#browser-push-seek-push-permission').modal();
            }
            $('#browser-push-seek-push-permission').on('hide.bs.modal', function(e){
                t.setPushModalShown(true);
            });
        },
        permissionModalSubmitHandler: function(){
            var t = this;
            OneSignal.push(function() {
                OneSignal.on('subscriptionChange', function(isSubscribed) {
                    var t = this;
                    if(isSubscribed){
                        OneSignal.push(function() {
                            OneSignal.getUserId(function (userId) {
                                window.browserPushManager.saveOneSignalIdToSellerProfile(userId);
                            });
                        });
                    }
                });
                OneSignal.showNativePrompt();
                $('#browser-push-permission-modal-close').click();
            });
        },
        saveOneSignalIdToSellerProfile: function(userId){
            if(userId){
                Bark.api('seller/notification/webpush',
                    {'onesignal_userid': userId},
                    function (data) {  },
                    function (err) { },
                    'POST'
                )}
        },
        run: function(){
            this.checkPermissionAndShowModal();
        }

    };
    Object.assign(this, instancevars);

    return this;
}

export function SetupBrowserPushManager() {

	$(() => {
		if ($('#hb-browser-push-template').length > 0) {
			window.browserPushManager = new BrowserPushManager();
			// run it 2.5s after page load
			if (!browserPushManager.shouldAvoidCheck()) {
				window.setTimeout(function () {
					browserPushManager.run();
				}, 2500);
			}
		}
	});

}